import { Component,  EventEmitter,  OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {



  @Output() onSearch:EventEmitter<any> = new EventEmitter()

  @Output() onClear:EventEmitter<any> = new EventEmitter()


  constructor() {}

  ngOnInit() {
   
  }


  search () {

    this.onSearch.emit()

  }

  clear() {

    this.onClear.emit()
  }


}